import { Icon } from '@eventbrite/legacy-eds.icon';
import { useIntl } from 'react-intl';
import { useGlobalNavContext } from '../../../../state';
import { getHeapDataAttribute, HeapAttributes } from '../../../../utils/heap-data';
import logoStyle from './Logo.module.scss';
import { trackClickWithElementID } from '../../../../utils/tracking';

const METRIC_NAME_CLICK = 'GlobalNav - Logged out - Click - Eventbrite Logo (Web)';
const HEAP_IDENTIFIER_DESKTOP = 'desktop';
const HEAP_IDENTIFIER_MOBILE = 'mobile';

type LogoLinkProps = {
    url: string;
    ariaLabel?: string;
    variant: 'desktop' | 'mobile';
    logo: {
        backgroundColor?: string;
        iconType?: JSX.Element;
        iconColor?: string;
        iconTitle?: string;
        iconHeight?: string | number;
        iconWidth?: string | number;
    };
};

const LogoLink = ({ url, ariaLabel, variant, logo }: LogoLinkProps) => {
    const { Teams, Features, Components, Actions } = HeapAttributes;
    const heapIdentifier = variant === 'desktop' ? HEAP_IDENTIFIER_DESKTOP : HEAP_IDENTIFIER_MOBILE;

    return (
        <a
            href={url}
            aria-label={ariaLabel}
            style={{ backgroundColor: logo.backgroundColor }}
            className={logoStyle[variant]}
            tabIndex={0}
            onClick={() => trackClickWithElementID(METRIC_NAME_CLICK, heapIdentifier)}
            data-heap-id={getHeapDataAttribute({
                team: Teams.SEO,
                feature: Features.GlobalNav,
                component: Components.Logo,
                name: heapIdentifier,
                action: Actions.Click,
            })}
        >
            <Icon
                type={logo.iconType}
                color={logo.iconColor}
                title={logo.iconTitle}
                isBlockLevel={true}
                height={logo.iconHeight}
                width={logo.iconWidth}
            />
        </a>
    );
};

export const Logo = () => {
    const { env, logo } = useGlobalNavContext();
    const { formatMessage } = useIntl();
    const { ariaLabel, desktopLogo, mobileLogo } = logo ?? {};
    const url = new URL(logo?.path ?? '', env?.serverUrl ?? '').href;

    return (
        <>
            <LogoLink
                url={url}
                ariaLabel={ariaLabel && formatMessage(ariaLabel)}
                variant="desktop"
                logo={desktopLogo ?? {}}
            />
            <LogoLink
                url={url}
                ariaLabel={ariaLabel && formatMessage(ariaLabel)}
                variant="mobile"
                logo={mobileLogo ?? {}}
            />
        </>
    );
};
